import { communityBuilding, kristiOnVideo } from "@/lib/gcsImagePaths";
import { communityConnections, consumerAffairsLogo } from "@/lib/gcsImagePaths";
import { cornerShield, girlWithCap } from "@/lib/gcsImagePaths";
import { karaAtOberlinEvent } from "@/lib/gcsImagePaths";
import { newsweekLogo, realtorLogo, stackOfCash } from "@/lib/gcsImagePaths";
import { usaTodayLogo, washingtonPostLogo } from "@/lib/gcsImagePaths";
import { wralInterview } from "@/lib/gcsImagePaths";

import { communityDonations, communityNonprofit } from "@/lib/gcsImagePaths";
import { CommunityCard } from "@/types/community";
import { imageDimensions } from "./imageDimensions";

export const communityCards: CommunityCard[] = [
  {
    image: communityNonprofit,
    alt: "Nonprofit board leadership meeting",
    title: "Nonprofit Board Leadership",
    description:
      "We connect our employees to board opportunities at high-impact community organizations where they can make a difference.",
  },
  {
    image: communityBuilding,
    alt: "Volunteers building homes",
    title: "Building Home",
    description:
      "Every year, we contribute $250,000 to Habitat for Humanity to help build new homes for families in need.",
  },
  {
    image: communityDonations,
    alt: "Employee donation matching program",
    title: "Matching Employees",
    description:
      "We match employee charitable donations dollar for dollar to amplify the impact of their personal giving.",
  },
  {
    image: communityConnections,
    alt: "Local community connections event",
    title: "Local Connections",
    description:
      "Through community events, volunteer projects, and local partnerships, we show up to help our communities thrive.",
  },
];

export const consumerAffairsLogoDim = imageDimensions[consumerAffairsLogo];
export const newsweekLogoDim = imageDimensions[newsweekLogo];
export const realtorLogoDim = imageDimensions[realtorLogo];
export const usaTodayLogoDim = imageDimensions[usaTodayLogo];
export const washingtonPostLogoDim = imageDimensions[washingtonPostLogo];
export const stackOfCashDim = imageDimensions[stackOfCash];
export const karaAtOberlinEventDim = imageDimensions[karaAtOberlinEvent];
export const kristiOnVideoDim = imageDimensions[kristiOnVideo];
export const wralInterviewDim = imageDimensions[wralInterview];
export const girlWithCapDim = imageDimensions[girlWithCap];
export const cornerShieldDim = imageDimensions[cornerShield];
